import _ from "lodash";
import mobile from "is-mobile";
import converter from "number-to-words";
import moment from "moment";
import {
  CONTRACT_STATUS,
  LATES_EXEMPTED_BY_SYSTEM,
  QUOTA_PER_MONTH,
  QUOTA_PER_YEAR,
  SALARY_PLACEHOLDER,
  USER_ROLES,
} from "./constants";
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const convertToArray = (array) => {
  return _.map(array, function (obj) {
    return Object.keys(obj)
      .sort()
      .map(function (key) {
        return obj[key];
      });
  });
};
export const omitFields = (user, fieldsToBeOmit) => {
  return _.omit(user, fieldsToBeOmit);
};

export const convertToBase64 = (file) => {
  if (!file) return;
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

export const mappingTwoObjects = (target, src) => {
  const res = {};
  Object.keys(target).forEach((k) => (res[k] = src[k] ?? target[k]));
  return res;
};

export const matchIdInArray = (array, id) => {
  return array.find((object) => {
    if (object._id === id) {
      return object;
    }
  });
};

export const isMobile = () => {
  return mobile();
};

export const validateEmail = (email) => {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  )
    ? true
    : false;
};

export const validateName = (name) => {
  return /^[a-zA-Z\s]+$/.test(name);
};

export const validateNationalId = (national_id_number) => {
  return /^[0-9]{5}-[0-9]{7}-[0-9]$/.test(national_id_number) ? true : false;
};

export const validateNumber = (mobile_number) => {
  return /^((\+92)|(0092))-{0,1}\d{3}-{0,1}\d{7}$|^\d{11}$|^\d{4}-\d{7}$/.test(
    mobile_number
  )
    ? true
    : false;
};

export const getMonthName = (index) => {
  return months[index];
};

export const numbersToWords = (number) => {
  return getUserRole() == "Admin" ? converter.toWords(number) : SALARY_PLACEHOLDER;
};

export const daysInMonth = (month, year) => {
  return new Date(year, month, 0).getDate();
};

export const currencyFormat = (num, addSlashAndHyphen=false) => {
 const role = localStorage.getItem('Role');
  if (num === undefined) return false;
  if (role === USER_ROLES[0] || role === "Admin") {
    const formattedNum = "Rs " + Math.abs(num)?.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    return addSlashAndHyphen ? formattedNum + "/-" : formattedNum;
  } else {
    return "Rs XXXXX";
  }
};

export const currencyBankSlipFormat = (num) => {
  if (num === undefined) return false;
  return Math.abs(num)
    ?.toFixed(0)
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export const getPerviousMonth = () => {
  return moment().subtract(1, "month").format("YYYY-MM");
};
export const formatDateForInput  = (date) => {
  return moment(date).format("YYYY-MM");
};

export const formatDate = (date) => {
  return moment(date).format("ll");
};

export const formatTime = (time) => {
  return moment(time, "HH:mm A").format("HH:mm");
};

export const formatDateReverse = (date) => {
  return moment(date).format("YYYY-MM-DD");
};

export const getAlphaNumericDate = (date) => {
  const slipFormate = new Date(date).toLocaleString("en-US", {
    year: "numeric",
    month: "short",
  });
  return slipFormate;
};

// accumulate the salaries of all the employee
export const sumOfSalaryCalculate = (payrollData) => {
  const sum = payrollData?.reduce((accumulator, one) => {
    return accumulator + one.salary;
  }, 0);
  return sum;
};

// calculate final salary after deducting tax if had any
export const salaryCalculate = (payroll) => {
  let finalValue = payroll.tax
    ? payroll.final_salary - payroll.tax + payroll.bonus
    : payroll.final_salary + payroll.bonus;
  return finalValue;
};

export const getMonthAndYear = (date) => moment(date).format("MMM YY");

// calculate long month with year
export const getFullMonthNameWithYear = (date) => {
  return `${months[moment(date).month()]}  ${moment(date).year()}`;
};

//get long month name from date
export const getLongMonth = (date) => {
  return `${months[moment(date).month()]}`;
};

//get time period of 2 given month
export const getTimePriod = (startDate, endDate) => {
  const startmonth = moment(startDate).month();
  const endmonth = moment(endDate).month();
  const startyear = moment(startDate).year();
  const endyear = moment(endDate).year();
  return endyear === startyear
    ? `${endmonth - startmonth + 1} month` // for same year
    : `${
        12 - startmonth + endmonth + 1 + 12 * (endyear - startyear - 1)
      }  month`; // to calculate year difference
};

// calculate total earning
export const totalEarning = (
  basic_salary,
  medical_allowance,
  cash_incentive,
  over_time,
  fuel_adjustment,
  commission
) => {
  return (
    basic_salary +
    medical_allowance +
    cash_incentive +
    over_time +
    fuel_adjustment +
    commission
  );
};

// calculate total deduction
export const totalDeduction = (
  late_arrivals,
  leaves,
  parking,
  tax,
  other_deductions
) => {
  return late_arrivals + leaves + parking + tax + other_deductions;
};

export const getCurrentMonthLeaves = (leaves, date) => {
  const month = moment(date, "DD-MM-YYYY").month();
  const year = moment(date, "DD-MM-YYYY").year();
  return leaves.filter((leave) => {
    const leaveDate = moment(leave.date_start);
    return leaveDate.month() === month && leaveDate.year() === year;
  });
};

export const calculateTime = (time) => {
  return time.reduce(
    (pre, curr) => {
      const splitted = curr.split(":");
      let hours = 0;
      let minutes = 0;
      let seconds = 0;
      if (splitted.length) hours = Number(splitted[0]);
      if (splitted.length >= 2) minutes = Number(splitted[1]);
      if (splitted.length === 3) seconds = Number(splitted[2]);

      if (pre[2] + seconds >= 60) {
        const result = Math.floor((pre[2] + seconds) / 60);
        minutes += result;
        seconds = pre[2] + seconds - result * 60;
        pre[2] = 0;
      }

      if (pre[1] + minutes >= 60) {
        const result = Math.floor((pre[1] + minutes) / 60);
        hours += result;
        minutes = pre[1] + minutes - result * 60;
        pre[1] = 0;
      }
      return [pre[0] + hours, pre[1] + minutes, pre[2] + seconds];
    },
    [0, 0, 0]
  );
};

export const getFullName = (emp) => `${emp.first_name} ${emp.last_name}`;

export const getEmployeesContract = (employees) => {
  return employees
    .map((emp) => {
      emp.daysEnd = Math.round(
        moment(emp.contract_id?.ended_at).diff(moment(), "days", true)
      );
      return emp;
    })
    .filter((emp) => emp.daysEnd > 0 && emp.contract)
    .sort((a, b) => a.daysEnd - b.daysEnd)
    .slice(0, 5);
};

export const getEmployeeData = (employees, id) => {
  if (employees && employees.length > 0) {
    const emp = employees.find((emp) => emp._id == id);
    return {
      name: getFullName(emp),
      job: emp?.job_title,
      image: emp?.image,
    };
  }
};

export const sortByTime = (attendance) => {
  return attendance.sort((a, b) => {
    let timeA = a.clock_In.split(":");
    let timeB = b.clock_In.split(":");
    return timeA[0] - timeB[0] || timeA[1] - timeB[1];
  });
};

// Input: accumulatedMonthlySalary = 130000  accumulatedMonthlyHours = 10
// returns 13000.00
export function calculateRatePerHour(
  accumulatedMonthlySalary,
  accumulatedMonthlyHours
) {
  if (accumulatedMonthlySalary && accumulatedMonthlyHours) {
    const ratePerHour =
      parseFloat(accumulatedMonthlySalary) /
      parseFloat(accumulatedMonthlyHours);

    // Check if the result is Infinity and return 0 if it is
    if (isFinite(ratePerHour)) {
      return ratePerHour.toFixed(2);
    } else {
      return 0;
    }
  } else {
    return 0.0;
  }
}
// Calculate contract period in months based on contract created date and salary date
function calculateContractPeriodInMonthsTillSalaryDate(
  contract_created_date,
  salary_date
) {
  const today = moment();
  const currentYear = today.year();
  const contractYear = moment(contract_created_date).year();

  if (currentYear === contractYear) {
    const salaryMonth = moment(salary_date).month() + 1;
    const contractMonth = moment(contract_created_date).month();
    return salaryMonth - contractMonth;
  } else {
    return moment(salary_date).month() + 1
  }
}
/**
 * Calculate the number of earned leaves based on contract start date, used leaves, and salary date.
 */
export function getEarnedLeaves(
  contract_created_date,
  employeeUsedLeaves,
  salary_date,
  contract_status,
) {
  let periodStartDate;
  if (contract_status === CONTRACT_STATUS[1]) {
    // If the contract is renewed, start calculation from the start of the year
    periodStartDate = moment(salary_date).startOf('year');

  } else {
    // Otherwise, start from the contract created date
    periodStartDate = contract_created_date;
  }

  // Calculate the number of months between periodStartDate and salary_date
  const contractPeriodInMonths = calculateContractPeriodInMonthsTillSalaryDate(
    periodStartDate,
    salary_date
  );
  // Calculate earned leaves based on the contract period and used leaves
  const earnedLeaves =
    QUOTA_PER_MONTH * contractPeriodInMonths - employeeUsedLeaves;

  return earnedLeaves;
}

export function getAssignedQuota(contractData) {
  /**
   * Calculate yearly quota for a Permanent employee.
   * Effective date is when the contract was set to Permanent (`permanent_set_at`).
   * If absent, accept a direct date value or fall back to `started_at`.
   * `renewed_at` is ignored for quota purposes.
   */
  if (!contractData) return 0;

  const permanentEffectiveDate =
    typeof contractData === "string" || contractData instanceof Date
      ? contractData
      : contractData.permanent_set_at ||
        contractData.updated_at ||
        contractData.updatedAt ||
        contractData.started_at;

  if (!permanentEffectiveDate) return 0;

  const permanentYear = moment(permanentEffectiveDate).year();
  const currentYear = moment().year();

  if (permanentYear < currentYear) {
    return QUOTA_PER_YEAR;
  }

  const monthsRemainingInYear = 12 - moment(permanentEffectiveDate).month();
  return QUOTA_PER_MONTH * monthsRemainingInYear;
}
/**
 * Calculate advance-availed leaves based on used leaves, salary date, and contract created date.
 */
export function getAdvanceAvailedLeaves(
  usedLeaves,
  salary_date,
  contract_created_date,
  contract_status,
) {
  let periodStartDate;

  if (contract_status === CONTRACT_STATUS[1]) {
    // If the contract is renewed, start calculation from the start of the year
    periodStartDate = moment(salary_date).startOf('year');
  } else {
    // Otherwise, start from the contract created date
    periodStartDate = contract_created_date;
  }

  // Calculate contract period in months from the determined start date
  const contractPeriodInMonths = calculateContractPeriodInMonthsTillSalaryDate(
    periodStartDate,
    salary_date
  );

  // Calculate earned leaves
  const earnedLeaves = QUOTA_PER_MONTH * contractPeriodInMonths;

  // Calculate the difference between usedLeaves and earnedLeaves
  const advanceAvailed = usedLeaves - Math.abs(earnedLeaves);

  // Return the result, or 0 if it's negative
  return Math.max(advanceAvailed, 0);
}

export function calculateFinalSalary(data) {
  if (data.commission) {
    return data.final_salary - data.tax + data.commission;
  } else {
    return data.final_salary - data.tax;
  }
}

export function calculateNetSalary(payroll) {
  let finalValue;
  if (payroll.tax) {
    finalValue = payroll.final_salary - payroll.tax + payroll.bonus;
  } else {
    finalValue = payroll.final_salary + payroll.bonus;
  }

  if (payroll.commission) {
    return finalValue + payroll.commission;
  } else {
    return finalValue;
  }
}

export const getSystemExemptedLates = (lateArrivals) =>
 lateArrivals <= LATES_EXEMPTED_BY_SYSTEM
    ? lateArrivals
    : LATES_EXEMPTED_BY_SYSTEM;

export const getUserRole = () => localStorage.getItem("Role");

export const calculateGrossSalary = (basicSalay, medicalAllowance) =>
  currencyFormat((basicSalay + medicalAllowance), true)

export const createEmployeeId = (machineNumber, joiningDate) =>
  `SS - ${machineNumber} - ${new Date(joiningDate).getFullYear()}`;

export const getPronoun = (gender) => (gender === "male" ? "He" : "She");

export const getPosessivePronoun = (gender) =>
  gender === "male" ? "His" : "Her";


export const getCurrentMonth = () => {
  return moment().format('YYYY-MM');
}